// extracted by mini-css-extract-plugin
export default {"root":"classes_root__6nCqd","content":"classes_content__4N9UM","image":"classes_image__j35k0","button-container":"classes_button-container__tlzj4","icon":"classes_icon__5qZyp"};